module.exports = __webpack_public_path__ + "static/media/YF34_1.722acd08.jpg";